<template>
  <div class="wrapper">
    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width="">
        <el-form-item label="渠道名称">
          <el-input v-model="searchData.channelName" size="small" placeholder="请输入渠道名称" />
        </el-form-item>
        <el-form-item label="对接商务">
          <SelectAdmin v-model="searchData.businessUserId"></SelectAdmin>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" @click="getList">搜索</el-button>
          <el-button type="info" size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-divider></el-divider>

    <tp-table
      :isNeedSerialNumber="true"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import { getMonthListAPI } from "./api";
import SelectAdmin from "@/views/components/select-admin.vue";

const columns = [
  {
    label: "渠道名称",
    prop: "channelName",
    minWidth: "150",
    customRender(h, row) {
      return <p>{row["channelName"]}</p>;
    },
  },
  {
    label: "对接商务",
    prop: "businessUserName",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["businessUserName"]}</p>;
    },
  },
  {
    label: "PV",
    prop: "pv",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["pv"]}</p>;
    },
  },
  {
    label: "UV",
    prop: "uv",
    minWidth: "100",
    customRender(h, row) {
      return <p>{row["uv"]}</p>;
    },
  },
  {
    label: "注册用户数",
    prop: "registerUserNum",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["registerUserNum"]}</p>;
    },
  },
  {
    label: "产品点击量",
    prop: "productClickNum",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["productClickNum"]}</p>;
    },
  },
  {
    label: "点击转化率",
    prop: "ctr",
    minWidth: "120",
    customRender(h, row) {
      return <p>{row["ctr"] + '%'}</p>;
    },
  },
];

export default {
  name: "ChannelBiOverviewList",
  components: {SelectAdmin},
  mixins: [authBtnMixin],
  data() {
    return {
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        channelName: "",
        businessUserId: undefined,
      },
    };
  },

  provide() {
    return {
      context: this,
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },

  methods: {
    async getList() {
      const { channelName } = this.searchData;
      let params = { page: this.currentPage, pageSize: this.pageSize, channelName };
      const res = await getMonthListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.getList();
    }
  },
};
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .el-divider--horizontal {
    margin: 0 0 20px;
  }

  .el-form {
    .el-form-item {
      margin-right: 35px;
    }
  }
  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }
  .el-drawer {
    .el-drawer__header {
      font-size: 18px;
      font-weight: 600;
    }
    .goods-box {
      padding: 0 20px;
    }
  }
}
</style>
<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;
  .header-search {
    .el-form {
      .el-form-item {
        margin-right: 35px;
        .el-input {
          width: 250px;
        }
        .el-date-editor {
          .el-range-separator {
            padding: 0;
          }
          .el-range-input {
            width: 35%;
          }
        }
      }
    }
  }
  .el-date-editor .el-range-separator {
    padding: 0;
  }
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  .tp-table {
    .el-table__fixed-right {
      height: 100% !important;
    }
  }
}
</style>
